// removed by extract-text-webpack-plugin
module.exports = {"desktopContainer":"_3_ywsdDFJ9hqaYpb0BxUvI","container":"_1htnX39PSzQCyzvp2gRg0E","logo":"_2ANlWIVUGvKaVOZDeL1cYj","card":"_3kiIujmZokh7NcNnub5XVY","mobileContainer":"_4z8hAr24oTZIC-a6xDk1G","containerMobile":"_2sjKhsXB-uTG1UbQn_E3At","grid":"_1cuxUhD4moZfRCH6HpvOqk","row":"dEV2MBJEYDXng02mddNJ3","slide":"_2xI8LVdh0gHu1EcjWvUi6x","leftSpace":"_1T_lyXXjPcMqtCOHnBu1Aj"};


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/scss/components/header.scss
// module id = 202
// module chunks = 0